export class CodeElement {
  constructor(element) {
    this.element = element;

    if (!element) {
      return;
    }

    this.setupCodeCopy();
  }

  setupCodeCopy() {
    const copyButtons = this.element.querySelectorAll(".code-copy-button");

    copyButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        this.handleCopyButtonClick(button);
        return false;
      });
    });
  }

  async handleCopyButtonClick(button) {
    const codeElement = button.closest(".code-element");
    const textContainer = codeElement.querySelector(".code-text-only");

    if (!textContainer) return;

    const text = this.getDecodedText(textContainer.innerHTML);

    try {
      await this.copyTextToClipboard(text);
      this.updateButtonState(button, true);
    } catch (error) {
      console.error("Error copying text:", error);
      this.updateButtonState(button, false);
    }
  }

  getDecodedText(text) {
    return text
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&");
  }

  async copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      throw new Error("Clipboard API not available.");
    }

    await navigator.clipboard.writeText(text);
  }

  updateButtonState(button, succeeded) {
    button.innerHTML = succeeded ? "Copied!" : "Error!";

    this.resetButtonText(button);
  }

  resetButtonText(button, delay = 2000) {
    setTimeout(() => {
      button.innerHTML = '<i class="fa fa-clipboard"></i> Copy Code';
    }, delay);
  }
}

export function initializeCodeElements(selector) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element) => new CodeElement(element));
}
